import DateTime from 'luxon/src/datetime.js'
import { getPlanPrice } from '../utils/utils';

/* This example requires Tailwind CSS v2.0+ */
export default function Subscription({subscription}) {
  console.log(subscription);
  const Paddle = window.Paddle;
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
      <div className="flex items-center justify-between space-x-8">
        {/* Plan Name and Price */}
        <div className="flex-shrink-0">
          <h2 className="text-2xl font-bold text-gray-900">{subscription.plan.name} plan</h2>
          <p className="text-gray-500">USD {getPlanPrice(subscription.plan.name)} per month</p>
        </div>

        {/* Last Charge */}
        <div className="flex-shrink-0">
          <h3 className="text-sm font-medium text-gray-500">Last charge on</h3>
          <p className="mt-1 text-gray-900">
            {DateTime.fromISO(subscription.event_time).toLocaleString(DateTime.DATE_FULL)}
          </p>
        </div>

        {/* Next Billing Date */}
        <div className="flex-shrink-0">
          <h3 className="text-sm font-medium text-gray-500">Next billing date</h3>
          <p className="mt-1 text-gray-900">
            {DateTime.fromISO(subscription.next_bill_date).toLocaleString(DateTime.DATE_FULL)}
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center space-x-4 flex-shrink-0">
          <button
            onClick={() => {
              window.location.href = `/billing/manage?plan=${encodeURIComponent(JSON.stringify(subscription.plan))}`;
            }}
            className="inline-flex items-center px-4 py-2 border border-myviolet text-sm font-medium rounded-md text-mypurple bg-white hover:bg-gray-50 hover:text-myorange hover:border-myorange"
          >
            Manage Subscription
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              Paddle.Checkout.open({
                override: subscription.update_url
              })
            }}
            className="inline-flex items-center px-4 py-2 border border-myviolet hover:border-myorange text-sm font-medium rounded-md text-mypurple bg-white hover:bg-gray-50 hover:text-myorange"
          >
            Update payment details
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              Paddle.Checkout.open({
                override: subscription.cancel_url,
                success: 'https://console.unwrangle.com/billing'
              })
            }}
            className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white bg-mypurple hover:bg-myorange focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          >
            Cancel subscription
          </button>
        </div>
      </div>
    </div>
  )
}
